/**
 * NTL MOD for Slither.io — game mod for slither.io
 *
 * Declares one web-accessible-resource entry (fonts, images, audio, and the static
 * pages social.html / help.html) with no `use_dynamic_url`, but scopes its `matches`
 * to slither.io and slither.com only. So the resources load at a fixed URL, yet only a
 * page on those game origins can reach them — from anywhere else the fetch is blocked
 * and a negative proves nothing.
 *
 * Manifest verified against version 9.61.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'hpgaehmokjbdfkbgkeifbfogjalkpfgb';

export const ntlModSlitherIo: ExtensionDefinition = {
  id: ID,
  name: 'NTL MOD for Slither.io',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 60_000,
  requiredOrigin: 'https://slither.io',
  notes:
    'Static WAR scoped to slither.io / slither.com, so only those game origins can ' +
    'detect it. social.html and help.html are stable named pages, no dynamic URL.',
  signals: [
    {
      id: 'war-social-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch social.html — a static page exposed only to the slither.io game origins.',
      weight: 1,
      run: () => probeFetch(ID, 'social.html'),
    },
    {
      id: 'war-help-html',
      kind: 'web-accessible-resource',
      description: 'Fetch help.html — the other origin-scoped static page, corroborating.',
      weight: 0.5,
      run: () => probeFetch(ID, 'help.html'),
    },
  ],
};
